export default __webpack_public_path__ + "static/media/SK.5ff847c7.svg";